module.exports = __webpack_public_path__ + "img/logo.7d5c585d.svg";